import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { Picture } from './picture.model';

@Component({
  selector: 'picture',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
})
export class PictureComponent implements OnInit, OnChanges {
  @Input() data: Picture = {
    image: '',
    webp: false,
    altext: '',
    format: '',
    width: '',
    height: '',
    fill: false,
    // Optional below
    // mobile: boolean,
    // classes: string
    // id: string
  };
  url!: string;

  constructor() {}

  ngOnInit(): void {
    this.updateUrl();
  }

  ngOnChanges(): void {
    this.updateUrl();
  }

  updateUrl(): void {
    if (this.data && this.data.image) {
      this.url = `/assets/img/${this.data.image}.${
        this.data.format === '' ? 'png' : this.data.format
      }`;
    }
  }
}
